import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { deleteSupportingDocument } from './index';

export const createSupportingDocumentsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  deleteSupportingDocument: (instance: IPublicClientApplication, supportingDocumentId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteSupportingDocument(fetchContext, supportingDocumentId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteSupportingDocument', isInFlight);
    },
  ),
});
